/* eslint-disable no-console */

import { register } from 'register-service-worker'

import _Vue from 'vue'

import store from './store'
import { SHOW_NEW_VERSION_NOTIFICATION } from './store/mutations'

import { VueServiceWorker } from './shims-registerServiceWorker'

export function registerServiceWorker () {
  let isRefreshing = false

  let _registration: ServiceWorkerRegistration

  const state: VueServiceWorker = {
    skipWaiting () {
      if (_registration?.waiting) {
        _registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      } else {
        throw new Error('There is no service worker waiting')
      }
    }
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready (registration) {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )

      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!isRefreshing) {
          isRefreshing = true
          window.location.reload()
        }
      })

      setInterval(registration.update, 3600000) // one hour.
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')

      _registration = registration

      store.commit(SHOW_NEW_VERSION_NOTIFICATION)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })

  return state
}

if (process.env.NODE_ENV === 'production') {
  _Vue.use({
    install (Vue) {
      Vue.prototype.$serviceWorker = registerServiceWorker()
    }
  })
}
